@if (showBrandedLoader && isLoading) {
  <div id="Loading">
    <div class="grid-row">
      <div class="col">
        <div class="loader">
          <div class="nfloader">
            @if (!environment.enableCustomLoadingIndicator) {
              <ng-lottie [options]="loadingIndicatorOptions"></ng-lottie>
            }
            @if (environment.enableCustomLoadingIndicator && showNfLoadingIndicator) {
              <ng-lottie [options]="nfLoadingIndicatorOptions"></ng-lottie>
            }
            @if (environment.enableCustomLoadingIndicator && !showNfLoadingIndicator) {
              <ng-lottie [options]="neutralLoadingIndicatorOptions"></ng-lottie>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (!showBrandedLoader && isLoading) {
  <div class="spinner-container">
    <div class="spinner"></div>
  </div>
}
